import script from "./CollapsiblePropertyRics.vue?vue&type=script&setup=true&lang=js"
export * from "./CollapsiblePropertyRics.vue?vue&type=script&setup=true&lang=js"

import "./CollapsiblePropertyRics.vue?vue&type=style&index=0&id=4b09ebe7&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4b09ebe7"]])

export default __exports__